<template>
    <div>
        <form class="lockunlock-form" @submit.prevent="submit">
            <custom-input
                v-model="requestParams.FromExternalId"
                inputType="number"
                :title="$t('ACCOUNT_CARDS__FROM_ID')"
                @clear="externalIdFrom = ''"
                helperText="* Required"
                isRequired
            ></custom-input>
            <custom-input
                v-model="requestParams.ToExternalId"
                inputType="number"
                :title="$t('ACCOUNT_CARDS__TO_ID')"
                @clear="externalIdTo = ''"
                helperText="* Required"
                isRequired
            ></custom-input>
            <custom-select
                v-model="webShopId"
                :title="$t('ACCOUNT_CARDS__WEB_SHOP')"
                :options="webshopOptions"
                @clear="webShopId = ''"
            ></custom-select>
            <switcher v-model="unusedOnly" :title="$t('ACCOUNT_CARDS__UNUSED_ONLY')"></switcher>
            <three-way-checkbox v-model="locked" :title="$t('ACCOUNT_CARDS__LOCKED')"></three-way-checkbox>
            <button class="btn">{{ $t('ACCOUNT_CARDS__SAVE') }}</button>
        </form>
        <grid
            v-if="dataCount > 0"
            :fullGrid="true"
            :passedData="gridData"
            identificator="id"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="15"
            :title="locked ? $t('ACCOUNT_CARDS__LOCKED_CARDS') : $t('ACCOUNT_CARDS__UNLOCKED_CARDS')"
            @pageChanged="pageChangeHandler"
        ></grid>
        <div class="btn export" v-if="dataCount > 0" @click="exportData">
            <span>{{ $t('ACCOUNT_CARDS__EXPORT') }}</span>
            <i class="material-icons">cloud_download</i>
        </div>
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'
import Switcher from '@/components/ReusableComponents/Switcher/Switcher.vue'
import ThreeWayCheckbox from '@/components/ReusableComponents/ThreeWayCheckbox/ThreeWayCheckbox.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { exportToExcel } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        CustomInput,
        CustomSelect,
        Switcher,
        ThreeWayCheckbox,
        Grid,
    },
    props: {
        columns: Array,
        webshopOptions: Array,
    },
    data() {
        return {
            webShopId: '',
            unusedOnly: true,
            locked: null,
            requestParams: {
                FromInternalId: '',
                ToInternalId: '',
                Assigned: null,
                Activated: null,
                Locked: null,
                WebShopId: '',
                FromExternalId: '',
                ToExternalId: '',
                OrderColumn: '',
                OrderDirection: '',
                CurrentPage: 1,
                PageSize: 15,
            },
            gridData: [],
            dataCount: 0,
        }
    },
    computed: {
        webshops() {
            return this.$store.state.webshops
        },
    },
    methods: {
        submit() {
            axios
                .post('WebShop/LockUnlockAccountCards', {
                    webShopId: this.webShopId,
                    externalIdFrom: this.requestParams.FromExternalId,
                    externalIdTo: this.requestParams.ToExternalId,
                    unusedOnly: this.unusedOnly,
                    locked: this.locked,
                })
                .then(resp => {
                    if (resp.data.status == 1) {
                        this.getData()
                        this.$emit('expand')
                    }
                })
        },
        getData() {
            axios
                .get('WebShop/FilterAccountCards', {
                    params: { ...this.requestParams },
                })
                .then(resp => {
                    this.gridData = resp.data.response
                    this.dataCount =
                        resp.data.response.length > 0
                            ? resp.data.response[0].count
                            : 0
                })
        },
        pageChangeHandler(page) {
            this.requestParams.CurrentPage = page
            this.getData()
        },
        exportData() {
            axios
                .get('WebShop/FilterAccountCards', {params: {
                    ...this.requestParams,
                    GenerateExcelFile: true,
                }})
                .then(resp => {
                    exportToExcel(resp, 'Cards')
                })
        }
    },
}
</script>

<style scoped lang="scss">
form {
    display: flex;
    margin-bottom: 30 * $rem;

    /deep/ label,
    .switcher-container,
    .select-wrapper,
    .checkbox-wrapper {
        margin-right: 15 * $rem;
    }
}

.export {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15 * $rem;

    span {
        margin-right: 15 * $rem;
    }
}

@media only screen and (max-width: 1100px) {
    form {
        flex-wrap: wrap;
        margin-top: -25 * $rem;

        label,
        .switcher-container,
        .select-wrapper,
        .checkbox-wrapper,
        .btn {
            width: calc(33% - #{15 * $rem});
            margin-right: 15 * $rem;
            margin-top: 25 * $rem;
        }
    }
}

@media only screen and (max-width: 700px) {
    form {
        label,
        .switcher-container,
        .select-wrapper,
        .checkbox-wrapper,
        .btn {
            width: calc(50% - #{15 * $rem});
        }
    }
}

@media only screen and (max-width: 390px) {
    form {
        label,
        .switcher-container,
        .select-wrapper,
        .checkbox-wrapper,
        .btn {
            width: calc(100% - #{15 * $rem});
        }
    }
}
</style>
